import { render } from "./Renovacion02TC.vue?vue&type=template&id=387254bd&scoped=true"
import script from "./Renovacion02TC.vue?vue&type=script&lang=js"
export * from "./Renovacion02TC.vue?vue&type=script&lang=js"

import "@/assets/css/registro02TC.css?vue&type=style&index=0&id=387254bd&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-387254bd"]])

export default __exports__